import type { ReactNode } from "react";
import cx from "ui/cx";
import styles from "./MainPanelHeader.module.scss";

interface MainPanelHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  header: string;
  subheader?: ReactNode;
  headerMenu?: ReactNode;
}

export function MainPanelHeader({ header, subheader, headerMenu, children, ...props }: MainPanelHeaderProps) {
  const { className, ...rest } = props;
  return (
    <header className={cx(styles.mainPanelHeader, className)} {...rest}>
      <div className={styles.header}>
        <div className={styles.headerMenuGroup}>
          <h3>{header}</h3>
          {headerMenu}
        </div>
        {subheader && (
          <div className={styles.subheaderRow}>
            {typeof subheader === "string" ? <span className={styles.subheader}>{subheader}</span> : subheader}
          </div>
        )}
      </div>
      <div className={styles.headerActions}>{children}</div>
    </header>
  );
}
